export const HEADCOLORS = [
    {id : 1, colorName: 'red', hex: 'linear-gradient(141.84deg, #FFABAB 20.75%, #DC2626 100%)'},
    {id : 2, colorName: 'brown', hex: 'linear-gradient(135deg, #C18F70 39.06%, #8C4646 92.19%)'},
    {id : 3, colorName: 'green', hex: 'linear-gradient(133.15deg, #5E9D77 34.37%, #14532D 82.86%)'},
    {id : 4, colorName: 'purple', hex: 'linear-gradient(136.27deg, #C1A4E6 15.56%, #7C35FF 85.9%)'},
    {id : 5, colorName: 'black', hex: 'linear-gradient(303.27deg, #000000 8.67%, #A1A1AA 95.05%)'}
]

export const CUSTOMITEMS = {
    bg: [
        {bgId: 1, imageUrl: '/image/customItem/bg/bg1.png'},
        {bgId: 2, imageUrl: '/image/customItem/bg/bg2.png'},
        {bgId: 3, imageUrl: '/image/customItem/bg/bg3.png'},
        {bgId: 4, imageUrl: '/image/customItem/bg/bg4.png'},
        {bgId: 5, imageUrl: '/image/customItem/bg/bg5.png'}
    ],
    head: [
        {headId: 1, imageUrl: '/image/customItem/head/blackhead1.png', color: 'black'},
        {headId: 2, imageUrl: '/image/customItem/head/blackhead2.png', color: 'black'},
        {headId: 3, imageUrl: '/image/customItem/head/blackhead3.png', color: 'black'},
        {headId: 4, imageUrl: '/image/customItem/head/blackhead4.png', color: 'black'},
        {headId: 5, imageUrl: '/image/customItem/head/blackhead5.png', color: 'black'},
        {headId: 6, imageUrl: '/image/customItem/head/redhead1.png', color: 'red'},
        {headId: 7, imageUrl: '/image/customItem/head/redhead2.png', color: 'red'},
        {headId: 8, imageUrl: '/image/customItem/head/redhead3.png', color: 'red'},
        {headId: 9, imageUrl: '/image/customItem/head/redhead4.png', color: 'red'},
        {headId: 10, imageUrl: '/image/customItem/head/redhead5.png', color: 'red'},
        {headId: 11, imageUrl: '/image/customItem/head/brownhead1.png', color: 'brown'},
        {headId: 12, imageUrl: '/image/customItem/head/brownhead2.png', color: 'brown'},
        {headId: 13, imageUrl: '/image/customItem/head/brownhead3.png', color: 'brown'},
        {headId: 14, imageUrl: '/image/customItem/head/brownhead4.png', color: 'brown'},
        {headId: 15, imageUrl: '/image/customItem/head/brownhead5.png', color: 'brown'},
        {headId: 16, imageUrl: '/image/customItem/head/greenhead1.png', color: 'green'},
        {headId: 17, imageUrl: '/image/customItem/head/greenhead2.png', color: 'green'},
        {headId: 18, imageUrl: '/image/customItem/head/greenhead3.png', color: 'green'},
        {headId: 19, imageUrl: '/image/customItem/head/greenhead4.png', color: 'green'},
        {headId: 20, imageUrl: '/image/customItem/head/greenhead5.png', color: 'green'},
        {headId: 21, imageUrl: '/image/customItem/head/purplehead1.png', color: 'purple'},
        {headId: 22, imageUrl: '/image/customItem/head/purplehead2.png', color: 'purple'},
        {headId: 23, imageUrl: '/image/customItem/head/purplehead3.png', color: 'purple'},
        {headId: 24, imageUrl: '/image/customItem/head/purplehead4.png', color: 'purple'},
        {headId: 25, imageUrl: '/image/customItem/head/purplehead5.png', color: 'purple'},
    ],
    face:[
        {faceId: 1, imageUrl: '/image/customItem/face/face1.png'},
        {faceId: 2, imageUrl: '/image/customItem/face/face2.png'},
        {faceId: 3, imageUrl: '/image/customItem/face/face3.png'},
        {faceId: 4, imageUrl: '/image/customItem/face/face4.png'},
        {faceId: 5, imageUrl: '/image/customItem/face/face5.png'}
    ],
    clothes:[
        {clothesId: 1, imageUrl: '/image/customItem/clothes/clothes1.png'},
        {clothesId: 2, imageUrl: '/image/customItem/clothes/clothes2.png'},
        {clothesId: 3, imageUrl: '/image/customItem/clothes/clothes3.png'},
        {clothesId: 4, imageUrl: '/image/customItem/clothes/clothes4.png'},
        {clothesId: 5, imageUrl: '/image/customItem/clothes/clothes5.png'},
        {clothesId: 6, imageUrl: '/image/customItem/clothes/clothes6.png'}
    ],
    accessory:[
        {accessoryId: 1, imageUrl: '/image/customItem/accessory/accessory1.png'},
        {accessoryId: 2, imageUrl: '/image/customItem/accessory/accessory2.png'},
        {accessoryId: 3, imageUrl: '/image/customItem/accessory/accessory3.png'},
        {accessoryId: 4, imageUrl: '/image/customItem/accessory/accessory4.png'},
        {accessoryId: 5, imageUrl: '/image/customItem/accessory/accessory5.png'},
    ]
}